import { api } from "..";
const endpoint = "/api/warehouses";

export const getWarehouseList = async () => {
  return await api.get(`${endpoint}`);
};

export const getWarehouseById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createWarehouse = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateWarehouse = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteWarehouse = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
}; 